export default function normalizeAssignType(v) {
  const x = String(v || "").trim().toUpperCase();
  if (x === "STATE" || x === "S" || x === "ST") return "STATE";
  if (x === "DISTRICT" || x === "D" || x === "DT") return "DISTRICT";
  return x || "STATE";
}